import { useSearchParams } from 'next/navigation';
import { useContext } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';

import AuthForm from '@/components/authForm/AuthForm';
import { SubscribeContext } from '@/components/subscribe/SubscribeContextProvider';
import { useAuthPrompt } from '@/context/auth/AuthPromptProvider';
import { usePricesState } from '@/hooks/store';
import genericMessages from '@/messages/messages';
import { setPurchaseParams } from '@/store/purchaseParams/actions';
import { User } from '@/store/user/types';
import { initPurchaseParams } from '@/utils/getInitialState';

import { Heading, Wrapper } from './styles';

const AccountScreen = () => {
	const { formatMessage } = useIntl();
	const { authPrompt } = useAuthPrompt();
	const prices = usePricesState();
	const { setActiveScreen } = useContext(SubscribeContext);
	const searchParams = useSearchParams();
	const dispatch = useDispatch();

	const onAuthSuccess = (newUser: User) => {
		const isShareSignup = searchParams?.get('context') === 'shared_linked_upsell';
		const couponToPass = isShareSignup ? 'freetrial' : searchParams?.get('coupon');
		const newPurchaseParams = initPurchaseParams({
			prices,
			query: searchParams ? Object.fromEntries(searchParams.entries()) : {},
			user: newUser,
			routeSpecificPurchaseParams: {
				coupon: typeof couponToPass === 'string' ? couponToPass : '',
				is30DayOverride: isShareSignup,
			},
		});
		dispatch(setPurchaseParams(newPurchaseParams));
		setActiveScreen('payment');
	};

	return (
		<Wrapper>
			<Heading>
				{formatMessage(authPrompt === 'signup' ? genericMessages.signupTitle : genericMessages.loginTitle)}
			</Heading>
			<AuthForm onAuthSuccess={onAuthSuccess} />
		</Wrapper>
	);
};

export default AccountScreen;
